import {
  SR_API_ACTION_HOUSEHOLD_PAY_APPLICATION,
} from 'api/actionTypes';

export default async function payApplication(
  { state, apiClient },
  { source, applicationId, skipUpdateHouseholdApplicationStatus },
) {
  await apiClient.postWithState({
    action: SR_API_ACTION_HOUSEHOLD_PAY_APPLICATION,
    state: state,
    payload: {
      source,
      applicationId,
      skipUpdateHouseholdApplicationStatus,
    },
    onSuccess(stripeCustomerId) {
      state.set(['currentUser', 'stripeCustomerId'], stripeCustomerId);
    },
    onError(error) {
      throw error;
    },
  });
}
